import React, { Component }  from 'react';

export default class Loading extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }


    render() {
        return (
            <div className="loding wrap">
                <div className="top table">
                    <div className="middle">
                        <div className="book">
                            <div className="book__page"></div>
                            <div className="book__page"></div>
                            <div className="book__page"></div>
                        </div>
                        <div className="txt">
                            <p id="movetext">Reason overruling and persuading necessity</p>
                            <p id="movename">Plato</p>
                        </div>
                    </div>
                </div>
                <div className="textClass bottom table">
                    <div className="middle">
                        <div className="">
                            <div className="title">
                                <h2 style={{fontSize:'18.59px'}}>
                                    We are searching through our database
                                </h2>
                                <div id="wave">
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                    <span className="dot"></span>
                                </div>
                            </div>
                            <p>It may take a few minutes<br/>before we get the results ready for you.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js